import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'mzic-spinner',
  imports: [CommonModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
})
export class SpinnerComponent {}
